export const GET_VERSIONS = {
  GET_VERSIONS: '__VERSION__',
}
